jQuery(document).ready(($) => {
  document.documentElement.classList.remove('no-js');
  initApp($);
});

const initApp = ($) => {
  let $body = $('body');

  // GLOBAL
  const MainMenu = require('./modules/global/mainMenu');
  MainMenu.init();

  const Forms = require('./modules/global/forms');
  Forms.init();

  const Heros = require('./modules/global/heros');
  Heros.init();

  // PAGE DETECTION
  if ($body.hasClass('page-home')) {
    const FrontPage = require('./modules/pages/frontPage');
    FrontPage.init();
  }
};
